import { render, staticRenderFns } from "./drawerPopupSta.vue?vue&type=template&id=050f1570"
import script from "./drawerPopupSta.vue?vue&type=script&lang=js"
export * from "./drawerPopupSta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports